module.exports = __webpack_public_path__ + "static/media/warning.6a06b17f.svg";